
export default "/assets/minus-circle-micro.f61e4440.svg"